import { push } from 'react-router-redux'

import { httpRequest } from 'http'
import { UNITS_CREATE } from 'urls'

import { sendErrorNotification } from 'helpers/web_to_client'

import requestUnitCreateInfo from './unit_create_info'

export const UNITS_OPEN_WIZARD = 'units_create/OPEN_WIZARD'
export const UNITS_OPEN_BATTLE_ROOMS = 'units_create/OPEN_BATTLE_ROOMS'
export const UNITS_CREATE_REQUEST = 'units_create/REQUEST'
export const UNITS_CREATE_SUCCESS = 'units_create/SUCCESS'
export const UNITS_CREATE_ERROR = 'units_create/ERROR'

export function startRequest() {
    return {
        type: UNITS_CREATE_REQUEST,
        payload: {},
    }
}

export function requestSuccess() {
    const webToClient = [
        {
            handler: 'battleChosen',
            params: {},
        },
        {
            handler: 'closeWindow',
            params: {
                windowId: 'browser',
            },
        },
    ]
    return {
        type: UNITS_CREATE_SUCCESS,
        payload: { },
        meta: { webToClient },
    }
}

export function requestError(errorData) {
    sendErrorNotification(errorData)
    return {
        type: UNITS_CREATE_ERROR,
        payload: errorData,
    }
}

export function openBattleRooms() {
    return (dispatch, getState) => {
        const { isInGameBrowser } = getState().settings

        // Show in regular browser for dev and QA purposes
        const url = window.location.protocol + '//' + window.location.host + '/battleRooms.html#'

        if (!isInGameBrowser) {
            window.location.assign(url)
        }

        return dispatch({
            type: UNITS_OPEN_BATTLE_ROOMS,
            meta: {
                webToClient: {
                    handler: 'openBattleRooms',
                    params: { },
                },
            },
        })
    }
}

export function openBattleWizard(title) {
    return (dispatch, getState) => {
        const { settings: { isInGameBrowser } } = getState()
        if (isInGameBrowser) return dispatch({
            type: UNITS_OPEN_WIZARD,
            payload: { },
            meta: {
                webToClient: {
                    handler: 'openBrowser',
                    params: {
                        url: `${window.location.protocol}//${window.location.host}/#${UNITS_CREATE}`,
                        title,
                        width: 1008,
                        height: 630,
                        isModal: true,
                        showCreateWaiting: true,
                    },
                },
            },
        })

        // Show battle wizard in regular browser for dev and QA purposes
        dispatch(push(UNITS_CREATE))
    }
}

export default function createUnit(type, battleMode = null, direction = null) {
    return async (dispatch, getState) => {
        if (getState().unitCreate.inProgress) {
            return
        }
        dispatch(startRequest())

        const data = { type }
        if (direction !== null) {
            data.direction = direction
        }
        if (battleMode !== null) {
            data.battle_mode = battleMode
        }
        httpRequest('/game_api/units/create', 'POST', data)
            .then(
                () => dispatch(requestSuccess()),
                errorData => {
                    dispatch(requestError(errorData))
                    dispatch(requestUnitCreateInfo())
                }
            )
    }
}



// WEBPACK FOOTER //
// ./state/actions/unit_create.js